<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-08 19:41:07
 * @Description: 鲸鱼动态
 -->

<template>
  <div class="news-wrapper">
    <router-view></router-view>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.news-wrapper {
  padding: 20px;
}
</style>
